import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const QuoteFollowUpInput = () => {
  const { followUpId = '' } = useParams();
  const decodedId = followUpId ? atob(followUpId) : followUpId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'quoteFollowUp';

  useEffect(() => {
    if (followUpId) { setIsEditing(true); fetchDetails(); }
  }, [followUpId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['quoteFollowUp'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Quote Follow-Up details:', error); }
  };

  const fields = [{"name":"quote","label":"Quote","type":"number"},{"name":"scheduled_at","label":"Scheduled At","type":"datetime-local"},{"name":"notes","label":"Notes","type":"textarea"},{"name":"outcome","label":"Outcome","type":"text"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Quote Follow-Up' : 'Create Quote Follow-Up'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default QuoteFollowUpInput;